// Module
var code = `<div class="jumbotron-page social-media-approver-page">

  <div class="jumbotron-surface social-media-approver-filter">
    <div class="jumbotron-panel-head social-media-approver-filter-head">
      <div class="social-media-approver-filter-main">
        <span class="jumbotron-heading">Approver</span>
        <!-- The rules of the rotation are on the icon, because the operator
             needs them only when a post does not play. -->
        <i class="fas fa-info-circle social-media-approver-help" aria-hidden="true"
          title="Rotation rules:&#10;A post from the last {{\$ctrl.socialMediaConfig.postMaxAge}} hours is in rotation&#10;The newest {{\$ctrl.socialMediaConfig.postMinimumCount}} approved posts always play, whatever their age&#10;A video plays only up to {{\$ctrl.socialMediaConfig.videoMaxLength}} seconds"></i>
      </div>

      <select ng-model="\$ctrl._selectedApprovalStatus" ng-change="\$ctrl.fetchPosts()"
        class="form-select form-select-sm social-media-approver-status" aria-label="Approval status">
        <option ng-value="0">Waiting for approval</option>
        <option ng-value="1">Approved</option>
        <option ng-value="2">Rejected</option>
      </select>

      <div class="social-media-approver-counts">
        <span class="social-media-approver-count" title="Posts in this list">
          <i class="fab fa-instagram" aria-hidden="true"></i> {{\$ctrl._posts.length}}
        </span>
        <span ng-if="\$ctrl._selectedApprovalStatus == 1"
          class="jumbotron-chip social-media-approver-rotation is-ok"
          title="Posts in rotation (from the last {{\$ctrl.socialMediaConfig.postMaxAge}} hours)">
          <i class="fas fa-sync-alt" aria-hidden="true"></i> {{\$ctrl.inRotationCount}}
        </span>
      </div>
    </div>
    <curator-sync-status></curator-sync-status>
  </div>

  <div class="jumbotron-scroll social-media-approver-grid">
    <div class="jumbotron-surface social-media-approver-post"
      ng-repeat="post in \$ctrl._posts | limitTo:\$ctrl.visibleCount">

      <div class="jumbotron-panel-head social-media-approver-post-head">
        <div class="social-media-approver-post-title" title="Media id: {{post.curatorPostId}}">
          <span class="jumbotron-heading">#{{\$index + 1}}</span>
          <span class="jumbotron-note">of {{\$ctrl._posts.length}}</span>
        </div>
        <span ng-if="post.inRotation" class="jumbotron-chip social-media-approver-rotation is-ok"
          title="This post is in rotation">
          <i class="fas fa-sync-alt" aria-hidden="true"></i> In rotation
        </span>
        <span ng-if="!post.inRotation" class="jumbotron-chip social-media-approver-rotation"
          title="This post is older than {{\$ctrl.socialMediaConfig.postMaxAge}} hours">
          <i class="fas fa-clock" aria-hidden="true"></i> Out of rotation
        </span>
      </div>

      <div class="social-media-approver-post-body">

        <div class="social-media-approver-meta">
          <span class="jumbotron-kind-label">Type</span>
          <span>{{ post.type }}</span>
          <span class="jumbotron-kind-label">Created</span>
          <span>
            {{post.created | amUtc | amLocal | amDateFormat:'DD/MM/YYYY HH:mm'}}
            <span class="jumbotron-note" am-time-ago="post.created | amUtc | amLocal"></span>
          </span>
        </div>

        <span class="jumbotron-chip social-media-approver-official"
          ng-if="post.username === 'roskildefestival'">@roskildefestival</span>

        <div ng-switch on="post.type" class="social-media-approver-media">
          <div ng-switch-when="video">
            <video controls="controls" disableremoteplayback ng-src="{{post.url}}" type="video/mp4"
              preload="metadata" video-duration-check="post"
              video-max-length="\$ctrl.socialMediaConfig.videoMaxLength"></video>
            <div ng-if="post.videoTooLong" class="jumbotron-note-box is-bad social-media-approver-duration">
              <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
              The video is {{post.duration}} seconds. The limit is
              {{\$ctrl.socialMediaConfig.videoMaxLength}} seconds, so this video does not play.
            </div>
            <div ng-if="post.duration && !post.videoTooLong"
              class="jumbotron-note social-media-approver-duration">
              <i class="fas fa-check-circle social-media-approver-ok-mark" aria-hidden="true"></i>
              {{post.duration}} seconds
            </div>
          </div>
          <div ng-switch-when="image">
            <img src="{{post.url}}" alt="" loading="lazy">
          </div>
          <div ng-switch-default class="jumbotron-note">Unsupported media type</div>
        </div>

        <div class="social-media-approver-caption">
          <div ng-if="!post.isExpanded">{{ post.truncatedText }}</div>
          <div ng-if="post.isExpanded">{{ post.caption }}</div>
          <button type="button" class="btn btn-sm btn-outline-secondary social-media-approver-more"
            ng-click="\$ctrl.toggleText(post)" ng-if="\$ctrl.shouldTruncate(post.caption)">
            {{ post.isExpanded ? 'Read less' : 'Read more' }}
          </button>
        </div>

        <div class="social-media-approver-actions">
          <button type="button" class="btn btn-sm btn-discreet-danger"
            ng-click="\$ctrl.updatePostApproval(post.id, 2)" ng-disabled="post.approvalStatus == 2">
            Reject
          </button>
          <button type="button" class="btn btn-sm btn-primary"
            ng-click="\$ctrl.updatePostApproval(post.id, 1)" ng-disabled="post.approvalStatus == 1">
            Approve
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
`;
// Exports
export default code;